export default "__VITE_ASSET__Tn6f484x__"